export default __webpack_public_path__ + "static/media/IMG_4534.75edc408.JPG";